import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import * as masterdataService from "@/redux/services/masterdataService"
import { Company, CostCenter, Employee, ProductHierarchies, Search } from "@/models/masterdatas.model"
import { RootState } from "@/redux/store"

interface MasterdataState {
  employees: Employee[]
  companies: Company[]
  hiers: ProductHierarchies[]
  costcenters: CostCenter[]
}

const initialState: MasterdataState = {
  employees: [],
  companies: [],
  hiers: [],
  costcenters: [],
}

export const getEmployee = createAsyncThunk("masterdata/employee", async () => {
  return await masterdataService.getEmployee()
})

export const getCompany = createAsyncThunk("masterdata/company", async () => {
  return await masterdataService.getCompany()
})

export const getProductHier = createAsyncThunk("masterdata/hier", async () => {
  return await masterdataService.getProductHier()
})

export const getCostCenter = createAsyncThunk("masterdata/costcenter", async () => {
  return await masterdataService.getCostCenter()
})

export const postSearch = createAsyncThunk("masterdata/search", async (data: Search) => {
  return await masterdataService.postMasterSearch(data)
})


const masterdataSlice = createSlice({
  name: "masterdata",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEmployee.fulfilled, (state, action) => {
      state.employees = action.payload.result
    })
    builder.addCase(getCompany.fulfilled, (state, action) => {
      state.companies = action.payload.result
    })
    builder.addCase(getProductHier.fulfilled, (state, action) => {
      state.hiers = action.payload.result
    })
    builder.addCase(getCostCenter.fulfilled, (state, action) => {
      state.costcenters = action.payload.result
    })
  },
})

export const employeeSelector = (store: RootState): Employee[] => store.masterdata.employees
export const companySelector = (store: RootState): Company[] => store.masterdata.companies
export const hierSelector = (store: RootState): ProductHierarchies[] => store.masterdata.hiers
export const costCenterSelector = (store: RootState): CostCenter[] => store.masterdata.costcenters

export default masterdataSlice.reducer